import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { map } from 'rxjs';

import { CurrentRouteService } from '../route';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'lib-spinner',
  imports: [CommonModule, ProgressSpinnerModule, TranslocoDirective],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  isLoading$ = this.spinnerService.isLoading$.pipe(
    map(() =>
      this.spinnerService.isLoadingForRoute(
        this.currentRouteService.getRouteKey() ?? 'default',
      ),
    ),
  );

  constructor(
    public spinnerService: SpinnerService,
    private currentRouteService: CurrentRouteService,
  ) {}
}
